import { AfterViewInit, ChangeDetectorRef, Component } from '@angular/core';
import { Chart } from 'chart.js/auto';
import { InpatientService } from '../../../../services/inpatient.service';
import { IDashboardChart } from '../../../../interfaces/Dashboard/IDashboardChart';
import { TranslateService } from '@ngx-translate/core';
import { IDashboardData } from 'src/app/interfaces/Dashboard/IDashboardData';

@Component({
  selector: 'app-dashboard-inpatient-by-age',
  templateUrl: './dashboard-inpatient-by-age.component.html',
  styleUrls: ['./dashboard-inpatient-by-age.component.css'],
  standalone: false,
})
export class DashboardInpatientByAgeComponent implements AfterViewInit {
  constructor(
    private readonly inPatientService: InpatientService,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef
  ) {}
  ngAfterViewInit(): void {
    this.getData();
  }

  public InPatientAge: IDashboardChart | null = null;
  public allZeroData: boolean = true;

  BarChart(): void {
    const datasets = this.InPatientAge?.dataSet || [];
    const maxYAxisValue = this.setBuffer(this.InPatientAge?.dataSet!);

    const data = {
      labels: [''],
      datasets: datasets.map((dataset, index) => ({
        label: this.translate.instant(dataset.label || ''),
        data: dataset.data,
        backgroundColor: [dataset.backgroundColor],
        borderColor: 'rgba(128, 128, 128, 0.6)',
        borderRadius: 10,
        borderWidth: 1,
      })),
    };

    new Chart('inPatientAge', {
      type: 'bar',
      data: data,
      options: {
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true,
            max: maxYAxisValue,
            ticks: {
              stepSize: 1,
            },
          },
        },
        plugins: {
          title: {
            display: true,
            text: this.translate.instant('Inpatients by Age'),
          },
        },
      },
    });
  }

  setBuffer(data: IDashboardData[]): number {
    const numericData =
      data.flatMap(
        (dataSet) => dataSet.data?.map((str) => parseFloat(str) || 0) || [0]
      ) || 0;

    const maxDataValue = Math.max(...numericData);

    const buffer = 3;

    const maxYAxisValue = maxDataValue + buffer;

    return maxYAxisValue;
  }

  getData() {
    this.inPatientService.getDashboardInPatientByAge().subscribe({
      next: (response) => {
        this.InPatientAge = response?.data;
        this.cdr.detectChanges();
        this.allZeroData = this.InPatientAge?.dataSet!.every((dataset) =>
          dataset.data!.every((value) => parseFloat(value) === 0)
        );

        if (this.InPatientAge && !this.allZeroData) {
          setTimeout(() => {
            this.BarChart();
          });
        }
      },
      error: (err) => {},
    });
  }
}
